module.exports = __webpack_public_path__ + "img/sliders_2-02.d2edc32f.png";